import { useEffect, useState } from "react"

const useScrollToTop = () => {
  const [trigger, setTrigger] = useState(false)
  const [first, setFirst] = useState(true)

  const flip = () => setTrigger(s => !s)

  useEffect(() => {
    if (!first) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    } else {
      setFirst(false)
    }
  }, [trigger])

  return flip
}

export default useScrollToTop
